import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Bautagebuch from './pages/Bautagebuch';
import BautagebuchForm from './pages/BautagebuchForm';
import BautagebuchDetail from './pages/BautagebuchDetail';
import Material from './pages/Material';
import Baustellen from './pages/Baustellen';
import Team from './pages/Team';
import Zeiterfassung from './pages/Zeiterfassung';
import BaustellenAuswertung from './pages/BaustellenAuswertung';
import Projektfortschritt from './pages/Projektfortschritt';
import Projektpositionen from './pages/Projektpositionen';
import LvImport from './pages/LvImport';
import Stammdaten from './pages/Stammdaten';

function PrivateRoute({ children }) {
  const ctx = useAuth() || {};
  if (ctx.loading) return <div className="loading-screen"><div className="spinner" /></div>;
  return ctx.user ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const ctx = useAuth() || {};
  return ctx.user?.role === 'admin' ? children : <Navigate to="/" />;
}

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="bautagebuch" element={<Bautagebuch />} />
                <Route path="bautagebuch/erstellen" element={<BautagebuchForm />} />
                <Route path="bautagebuch/:id/bearbeiten" element={<BautagebuchForm />} />
                <Route path="bautagebuch/:id" element={<BautagebuchDetail />} />
                <Route path="material" element={<Material />} />
                <Route path="baustellen" element={<Baustellen />} />
                <Route path="team" element={<AdminRoute><Team /></AdminRoute>} />
                <Route path="zeiterfassung" element={<AdminRoute><Zeiterfassung /></AdminRoute>} />
                <Route path="auswertung" element={<AdminRoute><BaustellenAuswertung /></AdminRoute>} />
                <Route path="projektfortschritt" element={<AdminRoute><Projektfortschritt /></AdminRoute>} />
                <Route path="projektpositionen" element={<AdminRoute><Projektpositionen /></AdminRoute>} />
                <Route path="lv-import" element={<AdminRoute><LvImport /></AdminRoute>} />
                <Route path="stammdaten" element={<AdminRoute><Stammdaten /></AdminRoute>} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
